<template>
    <el-dialog class="relevanceDialog" title="选择关联内容" :visible.sync="dialogVisible" width="700" :close-on-click-modal="false" :close-on-press-escape="false">
        <div class="content">
            <div class="searchBox">
                <el-input placeholder="输入内容名称" v-model="kmcname"></el-input>
                <el-button @click="triggerSearch">搜索</el-button>
            </div>
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="课程" name="course">
                    <div class="noData" v-if="!list1.length">
                        <img :src="require('@/common/images/certificate/bg_nodata.png')" alt="">
                        <p>暂无数据</p>
                    </div>
                    <div class="scrollBox" v-else>
                        <el-table ref="multipleTable1" @select="handleSelectionChange" :show-header="false" :data="list1" tooltip-effect="dark" style="width: 100%">
                            <el-table-column type="selection" width="50"></el-table-column>
                            <el-table-column>
                                <template slot-scope="scope">
                                    <div class="msg">
                                        <div class="left">
                                            <img :src="scope.row.coverurl" alt="">
                                        </div>
                                        <div class="right">
                                            <div class="kmcname">{{scope.row.kmcname}}</div>
                                            <div class="price">{{parseFloat(scope.row.saleprice) > 0 ? scope.row.saleprice : '免费'}}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <p class="loadMore" v-if="pageinfo1.rowCount > list1.length" @click="loadMore1">点击加载更多</p>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="题库" name="questionBank">
                    <div class="noData" v-if="!list2.length">
                        <img :src="require('@/common/images/certificate/bg_nodata.png')" alt="">
                        <p>暂无数据</p>
                    </div>
                    <div class="scrollBox" v-else>
                        <el-table ref="multipleTable2" @select="handleSelectionChange" :show-header="false" :data="list2" tooltip-effect="dark" style="width: 100%">
                            <el-table-column type="selection" width="50"></el-table-column>
                            <el-table-column>
                                <template slot-scope="scope">
                                    <div class="msg">
                                        <div class="left">
                                            <img :src="scope.row.coverurl" alt="">
                                        </div>
                                        <div class="right">
                                            <div class="kmcname">{{scope.row.kmcname}}</div>
                                            <div class="price">{{parseFloat(scope.row.saleprice) > 0 ? scope.row.saleprice : '免费'}}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                        </el-table>
                        <p class="loadMore" v-if="pageinfo2.rowCount > list2.length" @click="loadMore2">点击加载更多</p>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="affirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import {getCertKMCInfoList} from 'api/operateToolApi'
import {mapActions} from 'vuex'
export default {
    name: 'relevanceDialog',
    data() {
        return {
            dialogVisible: false,
            activeName: 'course',
            page1: {
                page: 1,
                pageSize: 10
            },
            list1: [],
            pageinfo1: {},
            page2: {
                page: 1,
                pageSize: 10
            },
            list2: [],
            pageinfo2: {},
            selectItem: '',
            kmcname: ''
        }
    },
    methods: {
        affirm() {
            if (this.selectItem) {
                this.$router.push({
                    name: 'certificateEdit',
                    query: {
                        kmcinnerid: this.selectItem.kmcinnerid,
                        kmctype: this.selectItem.kmctype
                    }
                })
            } else {
                this.$message.error('请选择关联内容')
            }
        },
        triggerSearch() {
            this.page1.page = 1
            this.page2.page = 1
            this.list1 = []
            this.list2 = []
            this.getCertKMCInfoList()
        },
        handleSelectionChange(selection, row) {
            this.$refs.multipleTable1.clearSelection()
            if (this.$refs.multipleTable2) {
                this.$refs.multipleTable2.clearSelection()
            }
            if (this.activeName === 'course') {
                this.$refs.multipleTable1.toggleRowSelection(row)
            } else {
                this.$refs.multipleTable2.toggleRowSelection(row)
            }
            this.selectItem = row
        },
        open() {
            this.getCertKMCInfoList()
            this.selectItem = ''
        },
        handleClick(e) {
            if (this.activeName === 'course') {
                if (!this.list1.length) {
                    this.page1.page = 1
                    this.getCertKMCInfoList()
                }
            } else {
                if (!this.list2.length) {
                    this.page2.page = 1
                    this.getCertKMCInfoList()
                }
            }
            console.log(this.activeName)
        },
        loadMore1() {
            this.page1.page = ++this.page1.page
            this.getCertKMCInfoList()
        },
        loadMore2() {
            this.page2.page = ++this.page2.page
            this.getCertKMCInfoList()
        },
        getCertKMCInfoList() {
            this.setLoading(true)
            let params = {
                pageSize: 10,
                kmcname: this.kmcname
            }
            if (this.activeName === 'course') {
                params.page = this.page1.page
                params.kmctype = '7'
            } else {
                params.page = this.page2.page
                params.kmctype = '8'
            }
            getCertKMCInfoList({
                data: params,
                success: res => {
                    this.setLoading(false)
                    this.dialogVisible = true
                    if (params.kmctype === '7') {
                        if (params.page === 1) {
                            this.list1 = res.data.content
                        } else {
                            this.list1 = this.list1.concat(res.data.content)
                        }
                        this.pageinfo1 = res.data.pageinfo
                    } else {
                        if (params.page === 1) {
                            this.list2 = res.data.content
                        } else {
                            this.list2 = this.list2.concat(res.data.content)
                        }
                        this.pageinfo2 = res.data.pageinfo
                    }
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    }
}
</script>
<style lang="scss">
    .relevanceDialog {
        .content {
            .searchBox {
                display: flex;
                align-items: center;
                // margin-bottom: 18px;
                .el-input {
                    width: 240px;
                    margin-right: 20px;
                    height: 36px;
                }
                .el-button {
                    margin-bottom: 0;
                }
            }
            .el-tabs {
                .el-tabs__item {
                    width: 70px;
                    box-sizing: border-box;
                    text-align: center;
                }
                .el-tab-pane {
                    .noData {
                        padding-top: 92px;
                        text-align: center;
                        font-size: 14px;
                        color: #C0C4CC;
                        height: 380px;
                        box-sizing: border-box;
                        img {
                            width: 84px;
                            height: 84px;
                            // margin-bottom: 20px;
                        }
                    }
                    .scrollBox {
                        height: 380px;
                        overflow-y: scroll;
                        .el-table {
                            .msg {
                                display: flex;
                                align-items: center;
                                .left {
                                    width: 88px;
                                    height: 50px;
                                    margin-right: 20px;
                                    img {
                                        width: 88px;
                                        height: 50px;
                                    }
                                }
                                .right {
                                    font-size: 14px;
                                    .kmcname {
                                        max-width: 360px;
                                        color: #606266;
                                        margin-bottom: 8px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                    }
                                    .price {
                                        color: #F56C6C;
                                    }
                                }
                            }
                        }
                        .loadMore {
                            text-align: center;
                            font-size: 14px;
                            color: #606266;
                            padding: 10px 0;
                            cursor: pointer;
                            &:hover {
                                color: #409EFF;
                            }
                        }
                    }
                }
            }
        }
    }
</style>